import { useId } from 'react';

import { Field, RadioGroup as UIRadioGroup } from '@/components/ui';

import type { Option } from './Select';
import { useFieldContext } from './contexts';

type Props = {
  label?: string;
  options: Option[];
  row?: boolean;
  helperText?: string;
};

const firstError = (errors: unknown[]) => errors.find((e) => e !== undefined)?.toString();

export function RadioGroup({ label, options, row, helperText }: Props) {
  const field = useFieldContext<string>();
  const name = useId();
  const touched = field.state.meta.isTouched;
  const errMsg = touched ? firstError(field.state.meta.errors) : undefined;

  return (
    <Field label={label} error={errMsg} hint={!errMsg ? helperText : undefined}>
      <UIRadioGroup
        name={name}
        value={field.state.value ?? ''}
        options={options}
        row={row}
        onChange={(v) => field.handleChange(v)}
      />
    </Field>
  );
}
